import { Rule } from "antd/es/form";
import { useMemo } from "react";
import { ACCOUNT_NOT_FOUND, WRONG_ACCOUNT_NUMBER } from "../../../lib/constants";
import _ from "lodash";
import { AccountNumberOption } from "../components/Criteria/AccountNumberCriteriaSelect";

export const useAccountNumberRules = (optionsData: AccountNumberOption[]) => {
  const rules = useMemo(
    () => [
      () => ({
        validateTrigger: ["onSubmit"],
        validator(_r: Rule, value: undefined | string[]) {
          if (!value?.length) {
            return Promise.resolve();
          }

          for (const item of value) {
            const option = optionsData.find((data) => data.name === item);

            if (!option || option.isPending) {
              continue;
            }

            if (_.isNaN(+option.name)) {
              return Promise.reject(WRONG_ACCOUNT_NUMBER);
            }

            if (option.id === null) {
              return Promise.reject(ACCOUNT_NOT_FOUND);
            }
          }

          return Promise.resolve();
        }
      })
    ],
    [optionsData]
  );

  return { rules };
};
